export const recommendList = [
  {
    id: "r1",
    title: "星海纪元",
    cover: "https://readdy.ai/api/search-image?query=Anime%20cover%20art%20of%20a%20young%20female%20space%20pilot%20in%20a%20sleek%20white%20and%20yellow%20suit%20floating%20before%20a%20glowing%20starship%20window%2C%20star%20field%20background%2C%20vivid%20warm%20highlights%2C%20detailed%20character%20illustration%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=800&seq=banana-rec-01&orientation=portrait",
    genres: ["科幻", "冒险", "热血"],
    region: "中国大陆",
    year: "2026",
    status: "连载中",
    episodes: "26 集",
    score: 9.4,
    summary: "银河远征军穿越未知星域，只为寻找传说中的「星海之种」。少女林星晨在远征途中逐渐成长为真正的领航者。",
    reason: "宏大的宇宙世界观与细腻的人物成长线并存，星舰战斗的分镜极具张力，是近年来国产科幻动画的代表作。",
    content: [
      "故事发生在人类迈入星际时代的数百年后。为了寻找能够拯救母星能源危机的「星海之种」，银河远征军踏上了跨越星系的漫长航程。",
      "主角林星晨是一名天赋异禀却始终缺乏自信的年轻领航员。在一次意外中，她被迫承担起了指挥整支舰队的重任。",
      "随着航程的深入，远征军遭遇了神秘的星海风暴、失落的文明遗迹以及立场各异的星际势力，每个人都在旅途中面对自己的抉择。",
    ],
  },
  {
    id: "r2",
    title: "樱花之约",
    cover: "https://readdy.ai/api/search-image?query=Anime%20cover%20art%20of%20a%20teenage%20couple%20under%20blooming%20cherry%20blossom%20trees%20on%20a%20school%20path%2C%20soft%20pink%20petals%20floating%2C%20warm%20afternoon%20light%2C%20gentle%20romantic%20mood%2C%20detailed%20character%20illustration%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=800&seq=banana-rec-02&orientation=portrait",
    genres: ["恋爱", "青春", "治愈"],
    region: "日本",
    year: "2025",
    status: "已完结",
    episodes: "12 集",
    score: 9.1,
    summary: "毕业季的小镇，两个少年在樱花树下许下约定。当离别临近，那句未曾说出口的话，成了他们最珍贵的回忆。",
    reason: "情感描写细腻真挚，画面唯美治愈，配乐与情节的配合恰到好处，是青春恋爱题材的佳作。",
    content: [
      "故事从一座被樱花环绕的海边小镇开始。转学生桐生缘与青梅竹马在高中最后一年重逢，两人却发现彼此早已不是记忆中的模样。",
      "随着毕业季的临近，他们决定完成儿时未能兑现的约定——一起去看小镇山顶那棵百年樱花树开花。",
      "在这段短暂而珍贵的时光里，懵懂的心意、未说出口的话与即将到来的离别交织在一起，构成了一个关于成长与约定的温暖故事。",
    ],
  },
  {
    id: "r3",
    title: "机械之心",
    cover: "https://readdy.ai/api/search-image?query=Anime%20cover%20art%20of%20a%20determined%20young%20male%20mecha%20pilot%20in%20a%20hangar%2C%20glowing%20mechanical%20details%2C%20dramatic%20orange%20rim%20light%2C%20detailed%20character%20illustration%2C%20vertical%20poster%20composition%2C%20industrial%20background%2C%20no%20text&width=600&height=800&seq=banana-rec-03&orientation=portrait",
    genres: ["机甲", "科幻", "战争"],
    region: "日本",
    year: "2026",
    status: "连载中",
    episodes: "24 集",
    score: 9.3,
    summary: "当冰冷的机械被赋予「心」，少年驾驶员与他的机体一同，在战火中寻找人与机器的真正意义。",
    reason: "机甲设定硬核且富有想象力，战斗场面燃点十足，同时不乏对战争与人性的深刻思考。",
    content: [
      "在一个被长期战争撕裂的世界里，人类依靠名为「机械之心」的人形兵器维持着脆弱的平衡。",
      "主角雷戈是一名天赋出众却沉默寡言的年轻驾驶员。他与自己的机体之间，似乎存在着一种超越操作界面之外的奇妙联系。",
      "随着战局的升级，雷戈逐渐发现「机械之心」背后隐藏的秘密，而他的抉择将决定这场战争乃至人类文明的未来。",
    ],
  },
  {
    id: "r4",
    title: "幻境学院",
    cover: "https://readdy.ai/api/search-image?query=Anime%20cover%20art%20of%20a%20silver%20haired%20magical%20academy%20student%20casting%20a%20glowing%20spell%2C%20floating%20runes%2C%20warm%20golden%20magic%20light%2C%20detailed%20character%20illustration%2C%20vertical%20poster%20composition%2C%20dreamy%20castle%20background%2C%20no%20text&width=600&height=800&seq=banana-rec-04&orientation=portrait",
    genres: ["奇幻", "校园", "冒险"],
    region: "中国大陆",
    year: "2025",
    status: "已完结",
    episodes: "24 集",
    score: 8.9,
    summary: "在悬浮于云端的魔法学院里，一名普通的转学生意外唤醒了沉睡千年的古老力量，平静的校园生活就此被打破。",
    reason: "世界观设定精巧，魔法体系自洽，角色群像塑造鲜明，兼顾热血战斗与轻松日常。",
    content: [
      "幻境学院是一座悬浮于云端之上的魔法学府，汇聚了来自各地的天赋少年。转学生夜见初雪的到来，却让学院平静的氛围泛起了涟漪。",
      "在一次意外中，她无意间唤醒了一件沉睡千年的古老法器，随之而来的，是一连串扑朔迷离的事件与来自暗处的窥探。",
      "为了守护学院和朋友，夜见初雪与伙伴们一同踏上了揭开真相的旅程，也逐渐理解了自己与生俱来的力量意味着什么。",
    ],
  },
  {
    id: "r5",
    title: "山海食记",
    cover: "https://readdy.ai/api/search-image?query=Anime%20cover%20art%20of%20a%20cheerful%20young%20chef%20holding%20a%20steaming%20bowl%20of%20noodles%2C%20warm%20kitchen%20background%2C%20soft%20golden%20light%2C%20cozy%20healing%20mood%2C%20detailed%20character%20illustration%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=800&seq=banana-rec-05&orientation=portrait",
    genres: ["美食", "治愈", "奇幻"],
    region: "中国大陆",
    year: "2026",
    status: "连载中",
    episodes: "16 集",
    score: 9.0,
    summary: "少年厨师白泽继承了一本神秘的古食谱，只要烹制出其中的菜肴，便能召唤出《山海经》里的神兽。",
    reason: "美食的烟火气与上古神话奇想巧妙融合，画风温暖治愈，是治愈系观众的不二之选。",
    content: [
      "白泽是一位在小镇经营家庭餐馆的年轻厨师。在整理祖父遗物时，他发现了一本记载着上古菜肴的泛黄食谱。",
      "神奇的是，每当他成功烹制出食谱中的一道菜，便会有《山海经》里的神兽现身，与他分享一段关于味道与人情的古老故事。",
      "在一道道美食的背后，白泽不仅收获了珍贵的友谊，也逐渐理解了祖父留下的真正遗产——用食物传递温暖的心意。",
    ],
  },
  {
    id: "r6",
    title: "剑与晨星",
    cover: "https://readdy.ai/api/search-image?query=Anime%20cover%20art%20of%20a%20brave%20young%20swordswoman%20holding%20a%20glowing%20blade%20at%20sunrise%2C%20wind%20blowing%20her%20cloak%2C%20warm%20orange%20sky%2C%20adventurous%20mood%2C%20detailed%20character%20illustration%2C%20vertical%20poster%20composition%2C%20no%20text&width=600&height=800&seq=banana-rec-06&orientation=portrait",
    genres: ["冒险", "热血", "奇幻"],
    region: "日本",
    year: "2024",
    status: "已完结",
    episodes: "24 集",
    score: 8.8,
    summary: "为了寻找失落的晨星之剑，少女剑士苏离踏上了穿越大陆的旅程，一路上结识伙伴、对抗黑暗。",
    reason: "传统热血冒险的扎实之作，战斗作画流畅，伙伴羁绊的刻画令人动容，热血与感动并存。",
    content: [
      "传说中，晨星之剑是唯一能够驱散大陆黑暗的信物。为了寻找这把失落的宝剑，少女剑士苏离独自踏上了旅途。",
      "在旅途中，她结识了性格各异的伙伴，也一次次直面来自黑暗势力与自身心魔的考验。",
      "当最终的决战来临，苏离终于明白，真正的力量并不只来自手中的剑，更来自她与伙伴们并肩而立的信念。",
    ],
  },
];